<div class="grid-container v-pad">
  <form-control-label [question]="componentData" [flow]="flowComponent"></form-control-label>
  @if (blockAdvance) {
    <div class="grid-x">
      <div class="cell large-12 bold red italic">
        Saving Casing Plan ...
      </div>
    </div>
  }
  @if (showFullView) {
    @if (currentStep !== steps.AlertsOverview) {
      <div class="grid-x">
        <div class="cell large-12">
          @if (currentStep === steps.Introduction) {
            <h3>Casing and Cementing Plans Introduction: Overview</h3>
            <div>
              If you are unfamiliar with the regulatory framework to prepare a well construction plan in the state of Ohio, it may be helpful to review the background information.
              <br />
              <br />
              <button class="button" (click)="goToRegulations()" [disabled]="isEdit">Regulations</button>
              <br />
              <br />
              <div class="checkbox">
                <input class="show-for-sr" type="checkbox" id="understandConfirm" [(ngModel)]="understandConfirm" [disabled]="!enableEditing">
                <label for="understandConfirm">
                  <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
                  <span class="control-label-text">* I understand the regulatory framework and am ready to develop a well construction plan.</span>
                </label>
              </div>
            </div>
          }
          @if (currentStep === steps.Regulations) {
            <new-casing-plan-background-info></new-casing-plan-background-info>
          }
        </div>
      </div>
    }
    @if (currentStep === steps.AlertsOverview) {
      <div class="cell large-12 bold margin-bottom">
        The following alerts apply to your proposed well site:
      </div>
      @for (alert of alertList; track alert) {
        <div class="cell large-12 margin-bottom">
          @if (alert.applicable) {
            <casing-plan-alert [alert]="alert"></casing-plan-alert>
          }
        </div>
      }
      @for (alert of observableAlertList; track alert) {
        <div class="cell large-12 margin-bottom">
          @if (alert.applicable) {
            <casing-plan-alert [alert]="alert"></casing-plan-alert>
          }
        </div>
      }
    }
  }
  @if (!showFullView) {
    <div class="grid-x margin-bottom">
      <div class="cell medium-6 large-4 text-center medium-text-left">
        You have <span class="bold red">{{unresolvedAlerts}}</span> unresolved alert(s).
      </div>
      <div class="cell medium-6 large-4 text-center medium-text-right large-text-center">
        You have <span class="bold green">{{resolvedAlerts}}</span> resolved alert(s).
      </div>
      <div class="cell medium-12 large-4 text-center large-text-right">
        You have <span class="bold">{{informationalAlerts}}</span> informational alert(s).
      </div>
      <div class="cell large-12 padding-left margin-bottom">
        @for (alert of alertList; track alert) {
          @if (showAlert(alert)) {
            <casing-plan-alert [alert]="alert"></casing-plan-alert>
          }
        }
      </div>
    </div>
    @if (currentStep === steps.ReviewCasingPlan) {
      <h3>Review Casing Plan</h3>
      @if (showNoAnglesWarning) {
        <div class="grid-x edit-warning padding-left padding-right margin-bottom">
          <div class="cell large-1">
            <svg-icon icon="icon-alert" class="small"></svg-icon>
          </div>
          <div class="cell large-11">
            You have selected a horizontal well but have not provided any angles.  You must either change your well orientation or provide angles before continuing.
          </div>
        </div>
      }
    }
    <div class="grid-x">
      @if (showPrecis) {
        <div class="cell large-12 margin-bottom">
          <well-segment-precis [wellSegment]="currentWellSegment" [segmentChanged]="segmentChanged"></well-segment-precis>
        </div>
      }
      <div class="cell large-12">
        @if (currentStep === steps.WellSegmentWizard) {
          @for (segment of casingPlan.wellSegments; track segment; let idx = $index) {
            <div class="margin-bottom">
              <well-segment-wizard [affirmComplete]="affirmComplete" [applicationData]="applicationData" [saveInProgress]="saveInProgress" [currentCasingPlan]="casingPlan" [enableEditing]="enableEditing" [isNewWell]="isNewWell" [position]="getPosition(idx)" [queueSegment]="segmentQueued" [requireAngles]="requireAngles" [wellDirection]="wellDirection" [wellSegment]="segment" [previousSegment]="getPreviousSegment(idx)" [activeEditing]="activeSegmentIndex === idx" [segmentIndex]="idx" [substep]="substep" (segmentAdded)="queueNewSegment($event)" (makeSegmentActive)="activeSegmentChanged($event)" [segmentChanged]="segmentChanged" [rulesService]="constructionService" (segmentDeleted)="deleteWarning($event)" (formReady)="onFormReady($event)"> </well-segment-wizard>
            </div>
          }
        }
        @if (currentStep === steps.ReviewCasingPlan) {
          <div class="grid-x grid-margin-x">
            @for (segment of casingPlan.wellSegments; track segment; let idx = $index) {
              <div class="cell medium-12">
                <div class="casing-title-bar grid-x">
                  <div class="cell auto">
                    String {{idx + 1}}: {{segment.casingType.definition}}
                  </div>
                  <div class="cell shrink">
                    @if (enableEditing) {
                      <a (click)="editWellSegment(segment)">Edit</a>
                      <a (click)="deleteWarning(idx)">Delete</a>
                    }
                    @if (!enableEditing) {
                      <a (click)="viewWellSegment(idx)">View</a>
                    }
                  </div>
                </div>
                <div class="grid-x grid-margin-x segment-attr-container margin-bottom">
                  @if (segment.casingCondition) {
                    <div class="cell small-12 medium-6">
                      <label class="inline segment-attr-text">Casing Condition:</label>
                      <span class="segment-attr-text">{{segment.casingCondition.name}}</span>
                    </div>
                  }
                  @if (segment.drillingEquipment) {
                    <div class="cell small-12 medium-6">
                      <label class="inline segment-attr-text">Drilling Equipment:</label>
                      <span class="segment-attr-text">{{segment.drillingEquipment.definition}}</span>
                    </div>
                  }
                  <div class="cell small-12 medium-6">
                    <label class="inline segment-attr-text">Borehole Diameter:</label>
                    <span class="segment-attr-text">{{segment.boreholeDiameter}}</span>
                  </div>
                  <div class="cell small-12 medium-6">
                    <label class="inline segment-attr-text">Borehole Depth:</label>
                    <span class="segment-attr-text">{{segment.boreholeDepth}} </span>
                  </div>
                  @if (segment.casingDiameter) {
                    <div class="cell small-12 medium-6">
                      <label class="inline segment-attr-text">Casing Diameter:</label>
                      <span class="segment-attr-text">{{segment.casingDiameter}}</span>
                    </div>
                  }
                  @if (segment.casingLength) {
                    <div class="cell small-12 medium-6">
                      <label class="inline segment-attr-text">Casing Length:</label>
                      <span class="segment-attr-text">{{segment.casingLength}} </span>
                    </div>
                  }
                  @if (objDefined(segment.toBePulled)) {
                    <div class="cell small-12 medium-6">
                      <label class="inline segment-attr-text">To Be Pulled?</label>
                      <span class="segment-attr-text">{{convertBoolean(segment.toBePulled)}}</span>
                    </div>
                  }
                  @if (segment.cementVolume) {
                    <div class="cell small-12 medium-6">
                      <label class="inline segment-attr-text">Cement Volume:</label>
                      <span class="segment-attr-text">{{segment.cementVolume}}</span>
                    </div>
                  }
                  @if (objDefined(segment.formation)) {
                    <div class="cell small-12 medium-6">
                      <label class="inline segment-attr-text"> Deepest Formation:</label>
                      <span class="segment-attr-text">{{segment.formation.definition}}</span>
                    </div>
                  }
                  @if (segment.packerDepth) {
                    <div class="cell small-12 medium-6">
                      <label class="inline segment-attr-text">Packer Depth:</label>
                      <span class="segment-attr-text">{{segment.packerDepth}}</span>
                    </div>
                  }
                  @if (segment.basketDepth) {
                    <div class="cell small-12 medium-6">
                      <label class="inline segment-attr-text">Basket Depth:</label>
                      <span class="segment-attr-text">{{segment.basketDepth}}</span>
                    </div>
                  }
                  @if (segment.floatCollarDepth) {
                    <div class="cell small-12 medium-6">
                      <label class="inline segment-attr-text">Collar Depth:</label>
                      <span class="segment-attr-text">{{segment.floatCollarDepth}}</span>
                    </div>
                  }
                  @if (objDefined(segment.zoneTestedOrProduced)) {
                    <div class="cell small-12 medium-6">
                      <label class="inline segment-attr-text">Zone Tested or Produced:</label>
                      <span class="segment-attr-text">{{convertBoolean(segment.zoneTestedOrProduced)}}</span>
                    </div>
                  }
                  <div class="cell small-12 medium-6">
                    <label class="inline segment-attr-text">Start Longitude:</label>
                    <span class="segment-attr-text">{{segment.gisObjects[0]?.longitude}}</span>
                  </div>
                  <div class="cell small-12 medium-6">
                    <label class="inline segment-attr-text">Start Latitude:</label>
                    <span class="segment-attr-text">{{segment.gisObjects[0]?.latitude}}</span>
                  </div>
                  <div class="cell small-12 medium-6">
                    <label class="inline segment-attr-text">End Longitude:</label>
                    <span class="segment-attr-text">{{segment.gisObjects[segment.gisObjects.length - 1]?.longitude}}</span>
                  </div>
                  <div class="cell small-12 medium-6">
                    <label class="inline segment-attr-text">End Latitude:</label>
                    <span class="segment-attr-text">{{segment.gisObjects[segment.gisObjects.length -1]?.latitude}}</span>
                  </div>
                  @if (objDefined(segment.hydraulicFracturing)) {
                    <div class="cell small-12 medium-6">
                      <label class="inline segment-attr-text">Hydraulic Fracturing:</label>
                      <span class="segment-attr-text">{{convertBoolean(segment.hydraulicFracturing)}}</span>
                    </div>
                  }
                </div>
                <div class="string-points-container">
                  <p class="minor-margin-bottom">String Points:</p>
                  @if (segment.gisObjects.length) {
                    <ag-grid-angular class="data-grid gis-ag-grid "
                      [rowData]="segment.gisObjects"
                      [columnDefs]="gisColumnDefsNoEdit"
                      (gridReady)="gisOnGridReady($event)"
                      [gridOptions]="gisGridOptions" aria-label="New Casing Plan">
                    </ag-grid-angular>
                  }
                </div>
              </div>
            }
          </div>
          <div class="casing-title-bar">Summary</div>
          <tabs class="major-margin-top display-block">
            <tab title="Schematic View">
              <casing-plan-2d-schematic [casingPlan]="casingPlan" [applicationData]="applicationData" [direction]="wellDirection"></casing-plan-2d-schematic>
            </tab>
            <tab title="3d View">
              <odnr-map [mode]="1" [casingPlan]="casingPlan" [longitude]="casingPlan.surfaceLongitude" [latitude]="casingPlan.surfaceLatitude" [zoom]="18"></odnr-map>
            </tab>
          </tabs>
          <div class="grid-x grid-margin-x">
            <div class="cell medium=12">
              <div class="checkbox">
                <input class="show-for-sr" type="checkbox" id="affirmComplete" [(ngModel)]="affirmComplete" [disabled]="!enableEditing">
                <label for="affirmComplete">
                  <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
                  <span class="control-label-text">* I certify that this is the proposed casing plan that I wish to submit for review.</span>
                </label>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="dialogConfirmed()" (onDialogClose)="onDialogClose()"></confirm-dialog>
